<div class="sidebar included">
    <app-sidebar-header [title]="'ancillaries.group.RQST' | ibeadmin: 'sync'" [label]="itemPriceText"></app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>

        <app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>
        <div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

        <app-included-per-passenger [flight]="flight" [feature]="feature" [brand]="brand" [passengers]="passengerList" *ngIf="flight">
        </app-included-per-passenger>

        <ng-container *ngIf="hasTAPOperatedFlight">
            <div class="sidebar-flight-text">
                <ng-container *ngIf="seatingAreaType === 'preferred'">
                    <h2 class="title-h2">
                        {{ 'whatsIncludedSidebars.detailsSeat.title.comfortSeatInfoTitle' | ibeadmin: 'sync' }}
                    </h2>
                    <p>
                        {{ 'whatsIncludedSidebars.detailsSeat.texts.comfortSeatInfo' | ibeadmin: 'sync' }}
                    </p>
                </ng-container>
                <ng-container *ngIf="seatingAreaType === 'standard' || seatingAreaType === 'business'">
                    <p>
                        {{ 'whatsIncludedSidebars.detailsSeat.texts.milesAndGoInfo' | ibeadmin: 'sync' }}
                    </p>
                </ng-container>
            </div>
            <div *ngIf="seatingAreaType === 'standard'" class="sidebar-flight-text">
                <h2 class="title-h2">
                    {{ 'whatsIncludedSidebars.detailsSeat.title.seatingInStandardArea' | ibeadmin: 'sync' }}
                </h2>
                <div class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding bg-gallery" (click)="INDRA_openSlideshow('standard')" style="cursor: pointer; background: url(./assets/images/ancillaries/includes/seats-reservation.jpg) no-repeat center center; background-size: cover;">
                        <div class="bg-dark"></div>
                        <app-svg class="list--gallery" svg="icons.svg#interface--gallery" aria-hidden="true" [alt]="'Gallery icon'">
                        </app-svg>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <div>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--not_available" aria-hidden="true" [alt]="'Not available icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.seatAreaCharacteristic1' | ibeadmin: 'sync' }}
                            </p>
                            <!--
							<p>
								<app-svg class="list--checked__icon" svg="icons.svg#general--not_available" aria-hidden="true"
									[alt]="'Not available icon'">
								</app-svg>
								{{ 'whatsIncludedSidebars.detailsSeat.texts.seatAreaCharacteristic2' | ibeadmin: 'sync' }}
							</p>
							-->
                        </div>
                        <a (click)="INDRA_gotoURL('externalURLs.aboutSeatsAndEatingAreas')" href="javascript:;" class="link extras-feature__link link--external" aria-label="Open All about seats and eating areas, opens new window">
							{{ 'whatsIncludedSidebars.detailsSeat.text.allAboutSeats' | ibeadmin: 'sync' }}
						</a>
                    </div>
                </div>
            </div>

            <div *ngIf="seatingAreaType === 'preferred' || hasOtherBrandWithEconomyExtra" class="sidebar-flight-text" [hidden]="seatingAreaType === 'standard'">
                <h2 class="title-h2">
                    {{ 'whatsIncludedSidebars.detailsSeat.title.seatingInEconomyExtraArea' | ibeadmin: 'sync' }}
                </h2>
                <div class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding bg-gallery" (click)="INDRA_openSlideshow('preferred')" style="cursor: pointer; background: url(./assets/images/ancillaries/includes/seats-reservation.jpg) no-repeat center center; background-size: cover;">
                        <div class="bg-dark"></div>
                        <app-svg class="list--gallery" svg="icons.svg#interface--gallery" aria-hidden="true" [alt]="'Gallery icon'">
                        </app-svg>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <div>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Checked icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.seatAreaCharacteristic3' | ibeadmin: 'sync' }}
                            </p>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Checked icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.seatAreaCharacteristic4' | ibeadmin: 'sync' }}
                            </p>
                            <!--
							<p>
								<app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true"
									[alt]="'Checked icon'">
								</app-svg>
								{{ 'whatsIncludedSidebars.detailsSeat.texts.seatAreaCharacteristic5' | ibeadmin: 'sync' }}
							</p>
							-->
                        </div>
                        <a (click)="INDRA_gotoURL('externalURLs.aboutSeatsAndEatingAreas')" href="javascript:;" class="link extras-feature__link link--external" aria-label="Open All about seats and eating areas, opens new window">
							{{ 'whatsIncludedSidebars.detailsSeat.text.allAboutSeats' | ibeadmin: 'sync' }}
						</a>
                    </div>
                </div>
            </div>

            <div *ngIf="seatingAreaType === 'business'" class="sidebar-flight-text">
                <h2 class="title-h2">
                    {{ 'whatsIncludedSidebars.detailsSeat.title.seatingInExecutiveArea' | ibeadmin: 'sync' }}
                </h2>
                <div class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding bg-gallery" (click)="INDRA_openSlideshow('business')" style="cursor: pointer; background: url(./assets/images/ancillaries/includes/seats-reservation.jpg) no-repeat center center; background-size: cover;">
                        <div class="bg-dark"></div>
                        <app-svg class="list--gallery" svg="icons.svg#interface--gallery" aria-hidden="true" [alt]="'Gallery icon'">
                        </app-svg>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <div>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Checked icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.NewExecutive1' | ibeadmin: 'sync' }}
                            </p>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Checked icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.NewExecutive2' | ibeadmin: 'sync' }}
                            </p>
                            <p>
                                <app-svg class="list--checked__icon" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Checked icon'">
                                </app-svg>
                                {{ 'whatsIncludedSidebars.detailsSeat.texts.NewExecutive3' | ibeadmin: 'sync' }}
                            </p>
                        </div>
                        <a (click)="INDRA_gotoURL('externalURLs.aboutSeatsAndEatingAreas')" href="javascript:;" class="link extras-feature__link link--external" aria-label="Open All about seats and eating areas, opens new window">
							{{ 'whatsIncludedSidebars.detailsSeat.text.allAboutSeats' | ibeadmin: 'sync' }}
						</a>
                    </div>
                </div>
            </div>

            <div class="sidebar-flight-text">
                <ng-container *ngIf="seatingAreaType === 'business'">
                    <p>
                        {{ 'whatsIncludedSidebars.detailsSeat.texts.seatReservationExecutiveClass' | ibeadmin: 'sync' }}
                    </p>
                </ng-container>
            </div>
        </ng-container>

        <app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>

        <div class="sidebar-flight-text border" *ngIf="reviewFlights && _hasEdit">
            <p class="muted">
                {{ 'whatsIncludedSidebars.detailsSeat.text.ifSeatNotChosen' | ibeadmin: 'sync' }}
            </p>
            <button class="button" aria-label="Open a dialog to Select Seats." (click)="moveToSeatsSidebar()">
				{{ 'whatsIncludedSidebars.detailsSeat.button.selectSeats' | ibeadmin: 'sync' }}
			</button>
        </div>

        <div class="extras__helper with-notification">
            <div class="">
                <a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					{{ 'whatsIncludedSidebars.detailsSeat.texts.closeWindow' | ibeadmin: 'sync' }}
				</a>
            </div>
        </div>
    </div>
    <div #sidebar__footer class="sidebar__footer "></div>
</div>